import { Check, Minus } from "lucide-react";
import { cn } from "@ui";

interface SelectionCheckboxProps {
  checked: boolean;
  indeterminate?: boolean;
  onChange: () => void;
  ariaLabel: string;
}

// Matches the app-wide selectable-list checkbox: a rounded box that is white
// with a default-200 ring at rest, default-500 ring on hover, and fills
// default-500 with a white check (or minus, when indeterminate) when active.
// A visually-hidden native input keeps it a real, accessible checkbox.
export function SelectionCheckbox({
  checked,
  indeterminate = false,
  onChange,
  ariaLabel,
}: SelectionCheckboxProps) {
  const active = checked || indeterminate;
  return (
    <label className="group relative inline-flex h-5 w-5 cursor-pointer items-center justify-center">
      {/* Input overlays the visible box (not sr-only/off-position) so click-focus
          never makes the scroll container jump the box into view. */}
      <input
        type="checkbox"
        aria-label={ariaLabel}
        checked={checked}
        ref={(el) => {
          if (el) el.indeterminate = indeterminate;
        }}
        onChange={onChange}
        className="absolute inset-0 m-0 cursor-pointer opacity-0"
      />
      <span
        className={cn(
          "pointer-events-none flex h-5 w-5 items-center justify-center rounded ring-1 transition-colors",
          active
            ? "bg-default-500 ring-default-500"
            : "bg-white ring-default-200 group-hover:ring-default-500",
        )}
      >
        {indeterminate ? (
          <Minus className="h-4 w-4 text-white" />
        ) : checked ? (
          <Check className="h-4 w-4 text-white" />
        ) : null}
      </span>
    </label>
  );
}
